import React, { useState } from 'react';
import PropTypes from 'prop-types';
import config from '../../../config/index';
import { toDesignation } from "../../../utils/helperServices";
import styles from './SortContainer.module.scss';

const SortContainer = ({ boxHeading, selectHandler, selected, close }) => {
	let [bgColor, setBgColor] = useState(selected);
	const changeColor = () => {
    setBgColor(selected = !selected)
		selectHandler(selected);
		close();
	};

	const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;
	return (
		<div className={styles.boxContainer} >
			<div
				className={bgColor && selected ? styles['box-clicked'] : styles.box}
				onClick={changeColor}
				id={`${boxHeading}-sortby`}
			>
				<h2 className={`${bgColor && selected ? styles['heading-clicked'] : styles.heading} ${toDesignation(boxHeading)}`} id={`${boxHeading}-sortby-after-unclicked`}>
					{boxHeading}
				</h2>
				{bgColor && selected && (
					<img src={`${imagePrefix}/assets/images/icon-green-tick.svg`} alt='selected' className={styles['check-mark']} id={`${boxHeading}-sortby-clicked`}/>
				)}
			</div>
		</div>
	);
};

SortContainer.propTypes = {
	boxHeading: PropTypes.string,
	selectHandler: PropTypes.func,
	selectedVal: PropTypes.string
};

export default SortContainer;
